// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_q6-5";
export var filledCircle = "_q6-4";
export var historyEntry = "_q6-3";
export var messageSideLeft = "_q6-1";
export var messageSideRight = "_q6-2";
export var orderTrackingCarouselWrapper = "_q6-6";
export var orderTrackingInfoContainer = "_q6-0";